<template>
  <div class="event-tickets">
    <memlist-card
      v-for="(t, i) in tickets"
      :key="i"
    >
      <!-- flex wrapper -->
      <div class="ticket-row">
        <!-- info -->
        <div class="ticket-info">
          <h4 class="ticket-name">{{ t.name }}</h4>
          <p v-if="t.companies.length" class="ticket-companies">
            {{ t.companies.join(', ') }}
          </p>

          <p v-if="t.membership_option">
            {{ $t('EVENT.TICKET.MEMBERSHIP_OPTIONS.'+t.membership_option) }}
          </p>
        </div>

        <!-- price -->
        <div class="ticket-price">
          {{ t.amount }} {{ t.currency }}
        </div>

        <!-- qty picker -->
        <div class="ticket-qty">
          <button class="qty-btn" @click="dec(i)">
            <span class="svg-icon-event-blue">
              <inline-svg src="/assets/svg/minus-square.svg" />
            </span>
          </button>

          <span class="qty">{{ t.qty }}</span>

          <button class="qty-btn" @click="inc(i)">
            <span class="svg-icon-event-blue">
              <inline-svg src="/assets/svg/plus-square.svg" />
            </span>
          </button>
        </div>
      </div>
    </memlist-card>
  </div>
</template>


<script>
export default {
  name: 'NewPublicEventSelectTicketsList',
  data() {
    return {
      tickets: [
        { name: 'Biljett För medlemmar', amount: 100, currency: 'SEK', companies: ['Förening 1', 'Förening 2'], qty: 0 },
        { name: 'Biljett För alla',      amount: 200, currency: 'SEK', companies: [],                              qty: 0 },
      ],
    };
  },
  methods: {
    inc(i) { this.tickets[i].qty += 1; },
    dec(i) { if (this.tickets[i].qty) this.tickets[i].qty -= 1; },
  },
};
</script>

<style scoped>
.event-tickets{
  display:grid;
  gap:12px;
}

.ticket-row{
  display:flex;
  align-items:center;
  gap:16px;
  padding:12px 16px;
}

.ticket-info{
  flex:1 1 auto;
  min-width:0;
}

.ticket-name{
  margin:0;
  font-size:1rem;
  font-weight:600;
}

.ticket-companies{
  margin:.25rem 0 0;
  font-size:.875rem;
  color:#6c757d;
}

.ticket-price{
  flex:0 0 110px;
  text-align:right;
  font-size:1.125rem;
  font-weight:600;
  color:#1f8a70;
}

.ticket-qty{
  margin-left:auto;
  display:flex;
  align-items:center;
  gap:8px;
}

.qty{
  min-width:24px;
  text-align:center;
}
.qty-btn{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  width:40px;
  height:40px;
  border:none;
  background:none;
  padding:0;
  cursor:pointer;
  transition:transform .06s ease-out;   /* animate scale */
}

/* tiny squash on press */
.qty-btn:active{
  transform:scale(.85);
}
.svg-icon-event-blue{
  width:24px;           /* icon stays the same */
  height:24px;
}
.svg-icon-event-blue :deep(svg){
  width:100%;
  height:100%;
  display:block;
  color:#35aaca;
  fill:currentColor;
}


</style>
